// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';

export const ProposedValue = zod.object({
  "source": ProposalSource,
  "value": zod.string()
});

export type ProposedValue = zod.input<typeof ProposedValue>;
export type ProposedValueOutput = zod.output<typeof ProposedValue>;
